export const PASSWORD_REQUIREMENTS = `Password needs to include both lowercase and uppercase characters, at least one number, and must be 8 or more characters long.`;
